import React from "react";

const Pantalon2 = ({ fillColor = "#FFDFC4", strokeColor = "#000000" }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 1220">
		<defs>
			<style>
				{`.cls-1 { fill: none; } .cls-2 { stroke-miterlimit: 10; }`}
			</style>
		</defs>
		<title>Base</title>
		<g id="cadre">
			<rect className="cls-1" width={408} height={1220} />
		</g>
		<g id="base">
			<path
				id="frame_1"
				data-name="frame 1"
				className="cls-2"
				fill={fillColor} // 👈 Apply dynamic fill color
				stroke={strokeColor} // 👈 Apply dynamic stroke color
				d="M991.5,957.5s-7.22,47.91-16.29,107.64c11.29-3.64,9.29,17.36-4.62,30.42-13.5,88.67-28.93,189.07-31.09,198.94-7,32-24,201-13,265,30,13,57,5,57,5s45-214,47-246,39-188,39-188a484.77,484.77,0,0,1,0,110c-7,59,30,317,30,317s47,6,75-25c-6-39-6-128,0-187s0-75,0-118,0-234-13-274C1152.5,922.5,991.5,957.5,991.5,957.5Z"
				transform="translate(-878.5 -427.5)"
			/>
		</g>
	</svg>
);

export default Pantalon2;
